/** @jsx jsx */
import {css, jsx} from '@emotion/core'
import React, {Fragment, useState} from 'react'
// import { isString } from 'lodash'
import {Col, Input, message, Row} from 'antd'
import {Modal} from 'antd-mobile'
import dateFormat from 'dateformat'
import NumberFormat, {NumberFormatValues} from 'react-number-format'
import {isMobile} from 'react-device-detect'
import useRootStore from '@store/useRootStore'
import {BettingFoldData, BettingFoldGrouped} from '@store/bettingHistoryStore'
import {observer} from 'mobx-react'
import {ArrDayText} from '@game/util'
import {getTicketCountFromTicket, showToast, titleTextPatternCheck, TOAST_TYPE} from '@utils/utils'
// image
import BetCouponImg1 from '@assets/images/icon/matchup_icon/betting-coupon-10000.png'
// icon
import {HeartIco} from '@shared/Icon/MoneyIcon'
// css
import styled, {Theme} from '@themes/theme'
import {ModalBg, Point, Right, TxtLimit} from '@styles/base.style'
import {Button, CheckboxBtn, CloseBtn} from '@styles/button.style'
import {PickHiddenWrap} from '@views/Pick/PickList/index.style'
import {BET_TICKET_TYPE, PUBLISH_PICK_TYPE} from '@constants/index'

const PickSaleWrap = styled.div`
  position: relative;
  height: 100%;
  overflow-x: visible;
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 22px;
    left: 50%;
    width: 100%;
    height: 10px;
    border-bottom: 1px solid ${props => props.theme.color.modalSubBg};
    transform: translate(-50%, 0);
  }
  .pick-sale-money {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    line-height: 6rem;
    &--select-type {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      min-width: 58px;
      height: 32px;
      line-height: 3.2rem;
      &:nth-of-type(2) {
        margin: 0 12px 0 4px;
      }
    }
    &--num {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 3.5;
      height: 32px;
      line-height: 3.2rem;
      padding: 0 10px 0 16px;
      color:  ${props => props.theme.color.modalTxt};
      background:  ${props => props.theme.color.modalSubBg};
      border-radius: 50px;
      &--txt {
        color: ${props => props.theme.color.modalSubTxt};
      }
      input {
        width: calc(100% - 56px);
        min-width: 0;
        margin-right: 6px;
        text-align: right;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.title};
        border: none;
        background: none;
      }
    }
    /*  heart */
    svg {
      width: auto;
      max-width: 20px;
      height: 14px;
    }
    /* bet-coupon */
    img {
      width: auto;
      max-width: 24px;
    }
  }
`
const RowStyle = css`
  margin: 2px 0;
  line-height: 2.8rem;
  text-align: left;
`
const Txt = styled.span`
  margin-right: 6px;
  color: ${props => props.theme.color.modalSubTxt};
  p {
    margin: 0 3px;
    font-size: inherit;
    color: inherit;
  }
  &.price {
    display: block;
    margin-top: 6px;
    font-size: ${props => props.theme.font.large};
  }
`

const FoldCount = styled.span`
  margin-right: 6px;
  font-size: ${props => props.theme.font.medium};
  color: ${props => props.theme.color.modalTxt};
`

const ListWrap = styled.div`
  z-index: 2;
  position: relative;
  left: -14px;
  width: 100vw;
  height: 100px;
  overflow-x: hidden;
  overflow-y: scroll;
  &.pick-sale {
    height: auto;
  }
`
const SendBtnStyle = (theme: Theme) => css`
  border-radius: 0;
  /* left: -10%; */
  left: -14px;
  bottom: 0;
  width: calc(100% + 28px);
  height: 36px;
`
const PointStyle = (theme: Theme) => css`
  color: ${theme.color.modalOrange};
`

// icon
const Heart = (
  <HeartIco/>
)
const BetCoupon = (
  <img src={BetCouponImg1} alt="베팅권"/>
)

function getMatchTrack(match: BettingFoldGrouped, fold: BettingFoldData, count: number) {
  const dateText = dateFormat(match.dateOfMatch, 'mm/dd')
  const timeText = dateFormat(match.dateOfMatch, 'HH:MM')
  const monthText = ArrDayText[new Date(match.dateOfMatch).getDay()]
  const dateOfMatchText = `${dateText}(${monthText}) ${timeText}`
  return (
    <PickHiddenWrap key={`pickSale_matchTrack_${match.matchId}_${count}`} className="pick-sale-modal">
      <h4 className="league-name">
        {`${match.sportName} - ${match.tournamentName}`}
      </h4>

      <div className="pick-match-info">
        <span className="pick-match-info--date">{dateOfMatchText}</span>
        <div className="pick-match-info--team">
          <span className="pick-match-info--team--name" css={TxtLimit}>{match.homeTeamName}</span>
          <span className="pick-match-info--team--score">VS</span>
          <span className="pick-match-info--team--name" css={TxtLimit}>{match.awayTeamName}</span>
        </div>
      </div>

      <div className="fold-wrap">
        <div key={`pickListItem_odds_${count}`} className="fold-wrap--bottom">
          <span className="fold-wrap--bottom--market-name">{fold.marketName}</span>
          <ul className="fold-wrap--bottom--select-result">
            <li className="txt">선택</li>
            <li className="hyphen">-</li>
            <li className="type">{fold.selectionName}</li>
            <li className="txt" style={{marginLeft: 10}}>결과</li>
            <li className="hyphen">-</li>
            <li className="type">대기</li>
          </ul>
        </div>
      </div>
    </PickHiddenWrap>
  )
}

const MAX_PICK_PRICE = 999999999

const PickSalePopup: React.FC = props => {
  const [title, setTitle] = useState('')
  const [price, setPrice] = useState(0)
  const [publishType, setPublishType] = useState(PUBLISH_PICK_TYPE.HEART)
  const [updator, setUpdator] = useState(0)

  const {bettingHistoryStore, pickStore, globalStore, authStore} = useRootStore()
  const {publishPickRecord} = bettingHistoryStore
  const visible = !!publishPickRecord
  const btnDisableCount = 10
  const visiblePublishBtn = getTicketCountFromTicket(BET_TICKET_TYPE.BET_TICKET1, authStore.userInfo.ticket)
    - btnDisableCount >= 0

  if (!visible && price > 0) {
    setPrice(0)
  }

  if (!visible && publishType !== PUBLISH_PICK_TYPE.HEART) {
    setPublishType(PUBLISH_PICK_TYPE.HEART)
  }

  const onTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = e.target
    setTitle(value)
  }

  const onPriceValueChange = (values: NumberFormatValues) => {
    const {value} = values
    const asNumber = Number(value)
    if (asNumber > MAX_PICK_PRICE) {
      setPrice(MAX_PICK_PRICE)
      setUpdator(updator + 1)
    } else {
      setPrice(asNumber)
    }
  }

  const onClickPublish = async () => {
    let priceAsNumber = 0
    try {
      priceAsNumber = Number(price)
    } catch (err) {
      // empty
    }

    if (title.length === 0) {
      message.warn('픽제목을 입력해주세요.')
      return
    }

    if (!titleTextPatternCheck(title)) {
      showToast(TOAST_TYPE.WARN, '한/영/숫자/공백을 조합하여 제목을 입력해 주세요.')
      return
    }

    if (title.trim() === '') {
      showToast(TOAST_TYPE.WARN, '공백만 입력하여 제목을 입력할 수 없습니다.')
      return
    }

    if (priceAsNumber <= 0) {
      showToast(TOAST_TYPE.INFO, '픽 판매가를 입력해 주세요.')
      return
    }

    if (priceAsNumber > MAX_PICK_PRICE) {
      message.warn('픽판매 최대 금액은 999,999,999 입니다.')
      return
    }
    globalStore.pushDialogWait({title: '알림', text: ['판매 등록중입니다...'], className: 'small-size'})
    await pickStore.publishPick(publishPickRecord.betId, title.trim(), priceAsNumber, publishType)
    globalStore.closeDialog()
    bettingHistoryStore.setPublishPickBetting('')
  }

  const eleMatchTracks = []
  let foldCount = 0
  let rate = '0'
  let firstDateOfMatchText = ''
  if (publishPickRecord) {
    const {bet, firstDateOfMatch} = publishPickRecord
    const dateInst = new Date(firstDateOfMatch)
    // dateInst.setMinutes(dateInst.getMinutes() - 5)
    const dateText = dateFormat(dateInst, 'mm/dd')
    const timeText = dateFormat(dateInst, 'HH:MM')
    const monthText = ArrDayText[new Date(dateInst).getDay()]
    firstDateOfMatchText = `${dateText}(${monthText}) ${timeText}`
    const {dividendRate} = bet
    rate = dividendRate || '0'
    let count = 1
    for (const matchId in publishPickRecord.folds) {
      const match = publishPickRecord.folds[matchId]
      for (const fold of match.data) {
        const track = getMatchTrack(match, fold, count)
        eleMatchTracks.push(track)
        count += 1
        foldCount += 1
      }
    }
  }

  const onClickPickSalePopupCloseButton = () => bettingHistoryStore.setPublishPickBetting('')
  const onClickHeart = () => {
    setPublishType(PUBLISH_PICK_TYPE.HEART)
    setPrice(0)
  }

  const onClickTicket = () => {
    setPublishType(PUBLISH_PICK_TYPE.TICKET)
    setPrice(0)
  }

  return (
    <Modal
      popup
      visible={visible}
      maskClosable={false}
      animated={isMobile}
      animationType="slide-up"
      onClose={onClickPickSalePopupCloseButton}
      className="short-top pc-close-btn-modal"
    >
      <Button circle onClick={onClickPickSalePopupCloseButton} css={CloseBtn}
              className="close-btn modal-circle-close-btn"><span className="close-txt">닫기</span></Button>

      <PickSaleWrap>
        <Input maxLength={20} placeholder="픽 제목을 입력해주세요. (20자 이내)" onChange={onTitleChange}/>

        <Row type="flex" justify="space-between" css={RowStyle}>
          <Col span={5}>
            <Txt>폴드</Txt>
            <FoldCount>{foldCount}</FoldCount>
          </Col>
          <Col span={5}>
            <Txt>배당</Txt>
            <Point css={PointStyle}>{rate}</Point>
          </Col>
          <Col span={14} css={Right}>
            <Txt style={{margin: 0}}>
              <p>베팅 마감</p>
              <p>{firstDateOfMatchText}</p>
            </Txt>
          </Col>
        </Row>

        <ListWrap className="modal-list pick-sale">{eleMatchTracks}</ListWrap>

        <div className="pick-sale-money">
          {visiblePublishBtn &&
          <Fragment>
            {/* ************ 베팅권을 100,000개 이상 보유시 출력 ************ */}
            <span className="pick-sale-money--select-type">
            <input type="radio" name="type" value="heart" defaultChecked id="selectHeart" css={CheckboxBtn}
                   onClick={onClickHeart}/>
            <label htmlFor="selectHeart">
              <span className="check-ico"/>
              {Heart}</label>
          </span>
            <span className="pick-sale-money--select-type">
            <input type="radio" name="type" value="bet-coupon" id="selectBetCoupon" css={CheckboxBtn}
                   onClick={onClickTicket}/>
            <label htmlFor="selectBetCoupon"><span className="check-ico"/>{BetCoupon}</label>
            </span>
            {/* *********************************************************** */}
          </Fragment>
          }

          <span className="pick-sale-money--num">
            <span className="pick-sale-money--num--txt">판매가</span>
            <NumberFormat
              pattern="\d*"
              maxLength={20}
              decimalScale={0}
              allowNegative={false}
              value={price || null}
              thousandSeparator
              onValueChange={onPriceValueChange}
            />
            {publishType === PUBLISH_PICK_TYPE.HEART ? Heart : '개'}
          </span>
        </div>

        <Button secondary css={SendBtnStyle} onClick={onClickPublish}>
          판매 등록하기
        </Button>
      </PickSaleWrap>

      <ModalBg onClick={onClickPickSalePopupCloseButton}/>
    </Modal>
  )
}

export default observer(PickSalePopup)
